import { createSlice } from "@reduxjs/toolkit";
import { getGroups } from "../actions/fluxoNSimilar";
import { GetGroupsResponse } from "../../types/gruposResponsabilidade";

interface GroupsState {
  groups: GetGroupsResponse | null;
  status: "idle" | "loading" | "ready" | "error";
  error: unknown;
}

const initialState: GroupsState = {
  groups: null,
  status: "idle",
  error: null,
};

const sessionGroupsSlice = createSlice({
  name: "sessionGroups",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGroups.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(getGroups.fulfilled, (state, action) => {
        state.status = "ready";
        state.groups = action.payload;
        state.error = null;
      })
      .addCase(getGroups.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload ?? action.error;
      });
  },
});

export default sessionGroupsSlice.reducer;
